export default function TokenomicsSection() {
  return <section className="py-20"><div className="text-center text-white">Tokenomics</div></section>;
}
